export const createTeamLabels = {
  name: "Name",
  logoUrl: "Image",
  type: "Access",
  games: "Games",
  description: "Description",
  criteriaPotm: "Criteria (player of the month)",
};
